import { Box } from '@mui/material';
import React from 'react';
import { ShimmerTitle } from 'react-shimmer-effects';

const BestCouponSkeleton = () => {
  return (
    <Box>
      <ShimmerTitle line={1} gap={10} variant="primary" />
    </Box>
  )
}

export default BestCouponSkeleton;
